import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDroplet12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconDroplet12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.5 7.846C9.5 9.514 8.01 11 6 11S2.5 9.514 2.5 7.846c0-1.975.97-3.717 2.026-5.018a13 13 0 0 1 1.436-1.503L6 1.292l.038.033c.392.35.914.86 1.436 1.503C8.529 4.128 9.5 5.87 9.5 7.846m1 0C10.5 10.14 8.485 12 6 12s-4.5-1.86-4.5-4.154C1.5 3.244 6 0 6 0s4.5 3.244 4.5 7.846M5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDroplet12);
